import {yupResolver} from '@hookform/resolvers/yup';
import Editor from '@monaco-editor/react';
import {Buffer} from 'buffer';
import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {toast} from 'react-hot-toast';
import {useNavigate, useParams} from 'react-router';
import * as yup from 'yup';
import {
  useGetOneTestSubmissionDetailQuery,
  useRunTestproblem,
  useSubmitScoreMutation,
} from '../../api/codingSubmission';
import {pageRoutes} from '../../routes';
import FormItem from '../jobForm/FormItem';
import Button from '../ui/Button';
import InputField from '../ui/InputField';
import Loader from '../ui/Loader';
import OutputWindow from './OutputWindow';

const convertToString = (data) => Buffer.from(data || '', 'base64').toString();
const toBase64 = (data) => Buffer.from(data?.trim()).toString('base64');

const ViewTestSubmission = () => {
  const {testId} = useParams();
  const [code, setCode] = useState('');
  const [outputDetails, setOutputDetails] = useState(null);
  const navigate = useNavigate();
  const {data: testDetailsResponse, isFetching: isTestDetailsLoading} =
    useGetOneTestSubmissionDetailQuery(testId);
  const testDetails = testDetailsResponse?.data || null;

  const scoreSchema = yup.object().shape({
    Score: yup
      .number()
      .max(
        testDetails?.problemId?.score || 0,
        'Score can note be more than problem score',
      )
      .typeError('Score is required')
      .required('Score is required'),
  });
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(scoreSchema),
    defaultValues: {
      Score: '',
    },
  });

  const {mutate: runTestMutation, isLoading: isRunTestIsLoading} =
    useRunTestproblem();

  const {mutate: sendScoreMutation, isLoading: isScoreLoading} =
    useSubmitScoreMutation();

  const handleRunTest = () => {
    const payload = {
      sourceCode: toBase64(code) || testDetails.sourceCode,
      languageId: testDetails?.testSubjectId?.compiler?.id,
    };

    runTestMutation(payload, {
      onSuccess: (res) => {
        setOutputDetails(res.data);
      },
    });
  };

  const handleSubmitScore = (value) => {
    const payload = {
      sourceCode: testDetails?.sourceCode,
      score: value.Score,
      status: 2,
      result: true,
    };

    sendScoreMutation(
      {...payload, testId},
      {
        onSuccess: (data) => {
          toast.success(data.message);
          navigate(pageRoutes.codingSubmission);
        },
      },
    );
  };

  return (
    <>
      {isTestDetailsLoading ? (
        <Loader />
      ) : (
        <div className="px-8 py-6">
          <div className="bg-white px-4 py-1 text-[20px] ">
            Candidate&apos;s output :{' '}
            {convertToString(testDetails?.output) || 'error'}
          </div>
          <div className="bg-white  px-4 py-1 text-[20px] ">
            Problem score : {testDetails?.problemId?.score}
          </div>
          <div className="p-4 bg-white">
            <div className="border border-2 p-4">
              <Editor
                height="40vh"
                defaultLanguage="javascript"
                onChange={(e) => setCode(e)}
                defaultValue={convertToString(testDetails?.sourceCode)}
                value={code}
              />
            </div>
          </div>
          <div className="bg-white p-4 mb-2">
            <OutputWindow outputDetails={outputDetails} />
            <div className="flex gap-4">
              <Button
                type="button"
                onClick={handleRunTest}
                loading={isRunTestIsLoading}
              >
                Run test
              </Button>
              <Button
                type="button"
                onClick={() =>
                  setCode(convertToString(testDetails?.sourceCode))
                }
              >
                Reset code
              </Button>
            </div>
          </div>

          <div className="bg-white mt-3">
            <form onSubmit={handleSubmit(handleSubmitScore)}>
              <div className="flex bg-white flex-col gap-6 p-4">
                <div className="flex border-b-2 border-gray-200 py-2 ">
                  <div className="text-[24px] font-bold">Give score</div>
                </div>
                <FormItem label="Score" htmlFor="score">
                  <InputField
                    {...register('Score')}
                    name="Score"
                    type="number"
                    placeholder="enter score"
                    error={errors.Score?.message}
                  />
                </FormItem>
              </div>
              <div className="py-5 px-4">
                <Button
                  type="submit"
                  className="w-[200px]"
                  loading={isScoreLoading}
                >
                  submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewTestSubmission;
